import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-cinema-surface">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">常见问答</h2>
          <p className="text-sm text-cinema-muted">你想了解的问题 · 都在这里</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-cinema-card border border-cinema-border rounded-xl overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-sm md:text-base font-semibold text-white mb-3 flex items-start gap-3">
                  <span className="flex-shrink-0 text-cinema-gold font-heading text-lg mt-[-2px]">Q</span>
                  <span>{item.q}</span>
                </h3>
                <p className="text-sm text-cinema-text-dim leading-relaxed flex items-start gap-3">
                  <span className="flex-shrink-0 text-cinema-muted font-heading text-lg mt-[-2px]">A</span>
                  <span>{item.a}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}